var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-container editor-container",class:{fullscreen:_vm.fullscreen}},[_c('textarea',{staticClass:"tinymce-textarea",staticStyle:{"width":"auto"},attrs:{"id":_vm.tinymceId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }